import * as QRCode from 'qrcode';

export const generateQR = async (text: string): Promise<string | undefined> => {
  try {
    return await QRCode.toDataURL(text);
  } catch (err) {
    console.error('QR generation error:', err);
  }
  return;
};
